import { render, staticRenderFns } from "./invoicesFilterBar.vue?vue&type=template&id=2480f5b9&"
import script from "./invoicesFilterBar.vue?vue&type=script&lang=js&"
export * from "./invoicesFilterBar.vue?vue&type=script&lang=js&"
import style0 from "./invoicesFilterBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports